import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8a112c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-error" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "申请失败", -1))
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "您本次贷款申请不通过！", -1))

import { ref } from 'vue'
import { Button } from 'vant'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-fail',
  setup(__props) {

const phoneNumber = ref('95599')

function phoneCallHandle() {
  appHost.postCallPhone(phoneNumber.value)
}

function onLeftClick() {
  appHost.goAppBack()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", null, [
        _createTextVNode(" 详情请咨询 "),
        _createElementVNode("span", {
          class: "phone",
          onClick: phoneCallHandle
        }, _toDisplayString(phoneNumber.value), 1)
      ])
    ]),
    _createVNode(_unref(Button), {
      class: "next-button xa-vant-button",
      onClick: onLeftClick
    }, {
      default: _withCtx(() => [
        _createTextVNode("我知道了")
      ]),
      _: 1
    })
  ]))
}
}

})